import englishMessages from 'ra-language-english';
import frenchMessage from 'ra-language-french';
import customFrenchMessages from './fr';
import customEnglishMessages from './en';

export default {
  fr: { ...frenchMessage, ...customFrenchMessages },
  en: { ...englishMessages, ...customEnglishMessages },
};
